import React from 'react';
import numeral from 'numeral';
import { Dispatcher } from "../components/gadgets/flux";

var Reader = {

  // Get all information about the given book
  // Needs to be cached, needs to work if booklist doesn't exist
  getBookInformation: function(isbn){
    var booklist = Fraction.Helpers.getDataObject("Library.BookList").books || [];
    var current_book, i;
    for (i=0;i < booklist.length;i++){
      current_book = booklist[i];
      if (current_book.isbn===isbn){
        return current_book;
      }
    }
    return {title: "This is a problem."};
  },

  setReaderTop: function(){
    this.runAfterRender(function(){ $("#reader-tools").css('top',$("#notification-container").height()+"px"); });
  },

  updateBookBounds: function(){
    return;
    // why this is commented out, who knows.  But it's probably important to keep
    /*
    this.runAfterRender(function(){
      $("#book-wrapper").css('left',$(".left-snap").width()+"px");
      $("#book-wrapper").css('right',$(".right-snap").width()+"px");
    });
    */
  },

  getBookDimensions: function(){
    return {width: $("#jigsaw-placeholder-outer").width(), height: $("#jigsaw-placeholder-outer").height()};
  },

  getContainerDimensions: function(){
    return {width: $("#reader-tools").width(), height: $("#reader-tools").height()};
  },

  updatePanelHandles: function(){
    this.runAfterRender(function(){
      if ($(".left-snap").length===0){
        $("#left-panels-handle").hide();
      } else {
        $("#left-panels-handle").show();
        $("#left-panels-handle").css("left",$(".left-snap").width()-$("#left-panels-handle").width());
      }
      if ($(".right-snap").length===0){
        $("#right-panels-handle").hide();
      } else {
        $("#right-panels-handle").show();
        $("#right-panels-handle").css("right",$(".right-snap").width()-$("#right-panels-handle").width());
      }
    });
  },

  explodeBookCache(array) {
    const keyList = [];
    const objList = [];
    array.forEach((obj) => {
      const keys = Object.keys(obj);
      keys.forEach((key) => {
        if (!keyList.includes(key)) {
          keyList.push(key);
        }
      });
      objList.push(keyList.map((key) => {
        return obj[key];
      }));
    });
    return {
      keys: keyList,
      values: objList
    };
  },

  rebuildBookCache(cache) {
    return cache.values.map((valueList) => {
      const implodedBookCached = {};
      cache.keys.forEach((key, i) => {
        implodedBookCached[key] = valueList[i];
      });
      return implodedBookCached;
    });
  },

  // Store the book list with a given key
  storeBookList: function(key, finished){
    try {
      var updatedAt = "";
      if (Fraction.User){
        updatedAt = Fraction.User.updatedBookListAt;
      }
      var obj = Fraction.Helpers.getDataObject("Library.BookList");
      obj.books.forEach((book) => {
        delete book.coverURL;
        delete book.url;
      });
      Fraction.Helpers.setItem(
        'fraction_data_bl',
        JSON.stringify({
          key,
          updated: updatedAt,
          data: {
            books: Fraction.Helpers.explodeBookCache(obj.books),
            coverURL: obj.coverURL
          }
        })
      );
      Fraction.Helpers.setItem('fraction_data_bl_fin', JSON.stringify({finished: finished}));
    } catch (e){}
  },

  // Load the book list with a given key
  loadBookList: function(key, lastUpdated){
    try {
      var obj = Fraction.Helpers.getDataObject("Library.BookList");
      var loadedBL = JSON.parse(Fraction.Helpers.getItem('fraction_data_bl'));
      loadedBL.data.books = Fraction.Helpers.rebuildBookCache(loadedBL.data.books);
      var finishedLoading = Fraction.Helpers.getDataObject("Library.FinishedBookList");
      finishedLoading.finished = JSON.parse(Fraction.Helpers.getItem('fraction_data_bl_fin')).finished; // did book list finish loading?

      var lastCached = new Date(loadedBL.updated);
      lastUpdated = new Date(lastUpdated);
      if (loadedBL.key === key && lastUpdated<=lastCached){
        obj.books = loadedBL.data.books;
        obj.coverURL = loadedBL.data.coverURL;
      } else {
        Fraction.Helpers.clearStoredBookList();
      }

    } catch(e){
      Fraction.Helpers.clearStoredBookList();
    }
  },

  touchBook: function(isbn){
    if (Fraction.User){
      Fraction.Helpers.loadBookList(Fraction.User.email.hashMe(), Fraction.User.updatedBookListAt);
      var obj = Fraction.Helpers.getDataObject("Library.BookList");
      if (obj && obj.books){
        for (var i=0;obj.books.length;i++){
          var book = obj.books[i];
          if (book.isbn === isbn){
            book.viewedAt = (new Date()).toISOString();
            obj.books.splice(i,1);
            obj.books.unshift(book);
            var finishedLoading = JSON.parse(localStorage.getItem('fraction_data_bl_fin')).finished;
            Fraction.Helpers.storeBookList(Fraction.User.email.hashMe(), finishedLoading);
            return;
          }
        }
      }
    }
  },

  // Clear the stored book list
  clearStoredBookList: function(){
    try {
      Fraction.Helpers.deleteDataObject("Library.BookList");
      Fraction.Helpers.setItem('fraction_data_bl', JSON.stringify({}));
      Fraction.Helpers.setItem('fraction_data_bl_fin', JSON.stringify({}));
    } catch(e){}
  },

  // Add a cover on top of the Jigsaw reader so
  // the iframe does not steal events
  coverReader: function(){
    $("#jigsaw-placeholder-outer").append('<div id="cover" style="position:absolute;top:0;left:0;right:0;bottom:0;z-index:5;background:rgba(0,0,0,0.00);-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;-o-user-select: none;user-select: none;pointer-events: all;"></div>');
    $(".panel").prepend('<div class="panel-cover" style="position:absolute;top:0;left:0;right:6px;bottom:0;z-index:5;background:rgba(0,0,0,0.00);-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;-o-user-select: none;user-select: none;pointer-events: all;"></div>');
    $("#book-wrapper").css("z-index",9);
    $("#panel-container").css("z-index",10);
  },

  // Uncover the reader so the iframe can be
  // interacted with as usual.
  uncoverReader: function(){
    $("#cover").remove();
    $(".panel-cover").remove();
    $("#book-wrapper").css("z-index","");
    $("#panel-container").css("z-index","");
  },

  addLoader: function(element, styles, text){
    if (!styles){ styles = ""; }
    if (!text){ text = ""; }
    if ($(element).children(".jquery-loader").size()===0){
      $(element).append("<div class='transient-loader jquery-loader' style='"+styles+"'><div></div><div class='innerContainer'><div class='spinning'></div><div style='margin-top:10px;'>"+text+"</div></div></div>");
    }
  },

  removeLoader: function(element){
    if (Fraction.Helpers.ignoreRemoveLoader){
      return;
    }
    $(element).find(".jquery-loader").remove();
  },

  copyURL: function(link){
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "copy-url", {link});
    Fraction.Reporter.gaEvent("reader/options/link-to-page");
  }

};

module.exports = Reader;
